export class cIOMAPPEDFREQUENCY {
  number: number = 0;
  inuse: boolean = false;
  frequency: number = 0;
  status: number = 0;
  statusstring: string = "--";
  rawdata: number = 0;
}

export interface FrequencyStatus {
  cIO_MAPPED_FREQUENCY: cIOMAPPEDFREQUENCY[];
}
